import { render } from "./ClientProposalRenewal.vue?vue&type=template&id=5af02e0a&scoped=true"
import script from "./ClientProposalRenewal.vue?vue&type=script&lang=js"
export * from "./ClientProposalRenewal.vue?vue&type=script&lang=js"

import "./ClientProposalRenewal.vue?vue&type=style&index=0&id=5af02e0a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af02e0a"]])

export default __exports__